import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { usePageMeta } from '@/hooks/usePageMeta';

const SERVICES = [
  {
    icon: 'ri-film-line',
    title: '影视资源浏览',
    desc: '涵盖电影与电视剧两大类，科幻、悬疑、都市、古装等多元题材，持续更新最新资源。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '精准分类筛选',
    desc: '支持按类型、年份、地区多条件组合筛选，并按更新时间、评分、热度排序，快速定位。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '影视资讯速递',
    desc: '提供票房动态、剧集热点与行业趋势资讯，让你在追剧的同时掌握影视圈的最新风向。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '本地收藏',
    desc: '喜欢的影视可一键收藏，保存在本设备浏览器中，刷新页面后依然保留，随时找回。',
  },
];

const NOTES = [
  '本站为演示性质的影视门户网站，所有影视资料、资讯内容与联系方式均为虚构示例，仅供学习交流使用。',
  '嫩草影院不提供真实在线播放服务，详情页的观看入口仅为展示占位，实际观看请前往正规版权平台。',
  '收藏功能通过浏览器本地存储实现，仅在当前设备生效，更换设备或清除浏览器数据后不会保留。',
  '分享功能为前端演示，点击后可复制当前页面链接，用于分享给好友。',
];

export default function About() {
  usePageMeta(
    '关于我们 - 嫩草影院品牌介绍与联系方式',
    '了解嫩草影院的品牌背景、服务宗旨与联系方式。嫩草影院致力于为用户提供最新电影电视剧资源与影视资讯。',
    '关于我们,嫩草影院,品牌介绍,联系方式',
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <Navbar />

      <main className="flex-1">
        {/* 品牌头部 */}
        <section className="relative w-full overflow-hidden border-b border-background-800">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20brand%20banner%2C%20abstract%20film%20strip%20and%20glowing%20green%20light%20ribbons%20on%20dark%20background%2C%20premium%20minimal%20editorial%20style%2C%20wide%20composition&width=1600&height=600&seq=nc-about-hero&orientation=landscape"
            alt="嫩草影院品牌介绍"
            title="嫩草影院 - 品牌介绍"
            className="absolute inset-0 h-full w-full object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/80 to-background-950/40" />
          <div className="relative mx-auto w-full px-4 py-16 md:px-6 md:py-20">
            <nav className="flex items-center gap-1.5 text-xs text-foreground-500">
              <Link to="/" className="transition-colors hover:text-primary-400">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-300">关于我们</span>
            </nav>
            <h1 className="mt-4 font-heading text-3xl font-extrabold text-foreground-50 md:text-4xl">
              关于嫩草影院
            </h1>
            <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-300 md:text-base">
              嫩草影院是一个聚焦“最新电影、电视剧在线播放与资讯”的综合影视门户，
              面向所有热爱影视、乐于追剧、关注行业动态的用户，致力于让每一次找片都更简单、更愉悦。
            </p>
          </div>
        </section>

        <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
          {/* 品牌介绍 */}
          <section className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
                品牌故事
              </h2>
              <p className="mt-4 text-sm leading-7 text-foreground-300">
                “嫩草”寓意新生与活力。我们希望像初春的嫩草一样，持续生长、不断更新，
                为用户带来源源不断的新鲜影视内容。从院线大片到热播剧集，从高分口碑到行业资讯，
                嫩草影院努力成为你打开手机时第一个想到的影视入口。
              </p>
              <p className="mt-3 text-sm leading-7 text-foreground-400">
                我们相信，好的内容值得被更好地发现。因此我们坚持清晰的分类、克制的界面与真实的信息呈现，
                让浏览影视本身成为一种放松的享受，而不是负担。
              </p>
            </div>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              <div className="rounded-lg border border-background-800 bg-background-900 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                  <i className="ri-flag-2-line text-xl" />
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-50">我们的定位</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-400">
                  综合影视门户，聚合资源浏览、分类筛选、详情查看与影视资讯。
                </p>
              </div>
              <div className="rounded-lg border border-background-800 bg-background-900 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15 text-accent-500">
                  <i className="ri-heart-3-line text-xl" />
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-50">服务宗旨</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-400">
                  用简单直接的方式，帮助每位影视爱好者快速找到想看的内容。
                </p>
              </div>
            </div>
          </section>

          {/* 我们提供什么 */}
          <section className="mt-14">
            <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
              我们提供什么
            </h2>
            <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {SERVICES.map((s) => (
                <div
                  key={s.title}
                  className="rounded-lg border border-background-800 bg-background-900 p-5 transition-colors hover:border-primary-700"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                    <i className={`${s.icon} text-2xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-50">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-400">{s.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 联系方式 */}
          <section className="mt-14">
            <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
              联系方式
            </h2>
            <p className="mt-2 text-sm text-foreground-400">
              以下联系方式均为演示示例，仅作展示用途。
            </p>
            <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-3">
              {[
                { icon: 'ri-mail-line', label: '客服邮箱', value: 'support@nencao-demo.com' },
                { icon: 'ri-customer-service-2-line', label: '合作邮箱', value: 'bd@nencao-demo.com' },
                { icon: 'ri-time-line', label: '服务时间', value: '周一至周五 09:00 - 18:00' },
              ].map((c) => (
                <div
                  key={c.label}
                  className="flex items-center gap-4 rounded-lg border border-background-800 bg-background-900 p-5"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-secondary-500/15 text-secondary-300">
                    <i className={`${c.icon} text-2xl`} />
                  </span>
                  <div className="min-w-0">
                    <p className="text-xs text-foreground-500">{c.label}</p>
                    <p className="mt-1 truncate text-sm font-medium text-foreground-100">
                      {c.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* 使用须知 */}
          <section className="mt-14">
            <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
              使用须知
            </h2>
            <ul className="mt-6 flex flex-col gap-3">
              {NOTES.map((note) => (
                <li
                  key={note}
                  className="flex items-start gap-3 rounded-lg border border-background-800 bg-background-900 px-5 py-4"
                >
                  <i className="ri-checkbox-circle-line mt-0.5 text-lg text-primary-400" />
                  <span className="text-sm leading-relaxed text-foreground-300">{note}</span>
                </li>
              ))}
            </ul>
          </section>

          <div className="mt-12 flex flex-wrap gap-3">
            <Link
              to="/category?type=movie"
              className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-film-line" />
              浏览电影
            </Link>
            <Link
              to="/news"
              className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-6 text-sm font-medium text-foreground-200 transition-colors hover:border-primary-600 hover:text-primary-400"
            >
              <i className="ri-newspaper-line" />
              阅读资讯
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}